// removed by extract-text-webpack-plugin
module.exports = {"studentPhoto":"src-components-ContentBox-BoxPhoto-__BoxPhoto-module___studentPhoto","checkbox":"src-components-ContentBox-BoxPhoto-__BoxPhoto-module___checkbox","indicator":"src-components-ContentBox-BoxPhoto-__BoxPhoto-module___indicator","boxActions":"src-components-ContentBox-BoxPhoto-__BoxPhoto-module___boxActions","boxContent":"src-components-ContentBox-BoxPhoto-__BoxPhoto-module___boxContent","faded":"src-components-ContentBox-BoxPhoto-__BoxPhoto-module___faded"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ContentBox/BoxPhoto/BoxPhoto.module.css
// module id = 159
// module chunks = 0